import React from 'react';

const Container = props => (
  <div className="text-blue-900 w-full">
    {props.children}
  </div>
);

export default Container;